/* Content-only enhancement: Shopify/Dawn and the installed VO app own selection. */
if (!customElements.get('sn-uv-rich')) {
  customElements.define('sn-uv-rich', class extends HTMLElement {
    connectedCallback() {
      try {
        const rows = JSON.parse(this.querySelector('[data-uv-config]').textContent);
        this.variants = new Map(rows.map(row => [String(row.id), row]));
      } catch (_) { return; }
      this.productInfo = [...document.querySelectorAll('product-info[id^="MainProduct-"]')]
        .find(info => info.dataset.productId === this.dataset.productId);
      if (!this.productInfo) return;
      this.onChange = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.syncFromForm());
      };
      this.productInfo.addEventListener('change', this.onChange);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
          const section = this.productInfo.dataset.originalSection || this.productInfo.dataset.section;
          if (!data || data.sectionId !== section || !data.variant) return;
          // When VO owns the picker, its actual variant-ID select is authoritative.
          if (this.productInfo.querySelector('#bcpo-select')) this.syncFromForm();
          else this.renderVariant(this.variants.get(String(data.variant.id)));
        });
      }
      this.syncFromForm();
      // VO may set .value without firing change. Read only; never alter its picker.
      this.appTimer = setInterval(() => {
        if (!document.hidden && this.productInfo.querySelector('#bcpo-select')) this.syncFromForm();
      }, 250);
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.productInfo?.removeEventListener('change', this.onChange);
      cancelAnimationFrame(this.frame);
      clearInterval(this.appTimer);
    }
    syncFromForm() {
      const input = this.productInfo.querySelector('#bcpo-select') ||
        this.productInfo.querySelector('product-form form [name="id"]');
      this.renderVariant(this.variants.get(String(input?.value)));
    }
    renderVariant(variant) {
      if (!variant || !variant.size || String(variant.id) === this.dataset.variantId) return;
      const set = (selector, text) => {
        const element = this.querySelector(selector);
        if (element) element.textContent = text;
      };
      set('[data-uv-heading]', `UV Security Ink — ${variant.size}`);
      set('[data-uv-copy]', variant.copy);
      set('[data-uv-size]', `${variant.size} bottle`);
      set('[data-uv-use]', variant.heading);
      set('[data-uv-price]', variant.price);
      set('[data-uv-availability]', variant.available ? 'Available' : 'Currently unavailable');
      this.querySelectorAll('[data-uv-card]').forEach(card => {
        const selected = card.dataset.uvCard === variant.size;
        card.classList.toggle('is-selected', selected);
        card.querySelector('[data-uv-selected]').textContent = selected ? 'Selected size' : '';
      });
      this.dataset.variantId = String(variant.id);
      set('[data-uv-status]', `${variant.size} bottle. ${variant.heading}. ${variant.price}. ${variant.available ? 'Available' : 'Currently unavailable'}.`);
    }
  });
}
